"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Content = ({ desktop, tablet, mobile, custoObjectInfo, children }) => {
    let componentClassName = 'content-gap';
    let editModal = null;
    if (custoObjectInfo) {
        editModal = () => {
            custoObjectInfo.handler(custoObjectInfo.entryPoint);
        };
        componentClassName = `${componentClassName} custo-editable`;
    }
    return (react_1.default.createElement("div", { className: `${componentClassName} col-sm-${tablet} col-lg-${desktop} col-xs-${mobile}` },
        editModal && (react_1.default.createElement("div", { className: "editable-button content", onClick: editModal }, "CP")),
        children));
};
exports.default = Content;
//# sourceMappingURL=index.js.map